import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { INewContact } from 'apps/fleet-planner/schema/ContactSchema'
import { IGetContactsParams } from 'apps/fleet-planner/types'
import * as Types from 'apps/fleet-planner/types'

/**
 * Creates a new contact entity
 * @method POST
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Customers/post_customers__id__contacts
 */
export const createNewCustomerContact = (
  customerId: string,
  contact: Pick<Types.ICustomerContact, 'email' | 'name' | 'phone' | 'phoneExt' | 'purpose'>
): Promise<Types.ICreateNewContactResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.customers}/${customerId}/contacts`,
    method: 'POST',
    body: contact,
  })
}

/**
 * Updates a contact entity
 * @method PUT
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Contacts/put_customers__customer_id__contacts__id_
 */
export const updateCustomerContact = (
  customerId: string,
  contactId: string,
  contact: INewContact
): Promise<Types.ICreateNewContactResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.customers}/${customerId}/contacts/${contactId}`,
    method: 'PUT',
    body: contact,
  })
}

/**
 * Retrieves a list of contacts that may be added to a shipment as a subscriber
 * @method GET
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Contacts/get_subscribable_contacts
 */
export const fetchSubscribableContacts = (search: string): Promise<Types.IGetContactsResponse> => {
  const params: IGetContactsParams = {
    search,
    sortOrder: 'asc',
    sortField: 'email',
  }
  return callApi({
    endpoint: `${FP_ENDPOINTS.subscribable_contacts}`,
    method: 'GET',
    params,
  })
}
